import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "label-wrapper"
}

import { computed, onMounted, ref, VNode } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Frame',
  props: {
  text: {
    type: String,
    default: null,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  top: {
    type: Number,
    required: true,
  },
  left: {
    type: Number,
    required: true,
  },
  radius: {
    type: String,
    default: "0",
  },
  hasBorder: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const textLabelNode = ref<HTMLElement | null>(null);

const frameStyle = computed(() => {
  return {
    top: props.top + "px",
    left: props.left + "px",
    width: props.width + "px",
    height: props.height + "px",
  };
});

const borderStyle = computed(() => {
  let clipPath = null;
  if (textLabelNode.value) {
    const halfLabelWidth = textLabelNode.value.offsetWidth / 2;
    const halfLabelHeight = textLabelNode.value.offsetHeight / 2;
    const p1x = props.width / 2 + halfLabelWidth;
    const p2y = props.height - 2;
    const p3x = props.width / 2 - halfLabelWidth;

    let dent = p1x + "px 100%, ";
    dent += p1x + "px " + p2y + "px, ";
    dent += "50% 50%, ";
    dent += p3x + "px " + p2y + "px, ";
    dent += p3x + "px 100%";

    clipPath = "polygon(0% 0%,100% 0%,100% 100%, " + dent + ", 0% 100%)";
  }

  return {
    "border-radius": props.radius,
    "clip-path": clipPath,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "framed-label",
    style: _normalizeStyle(frameStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.hasBorder)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "with-border",
          style: _normalizeStyle(borderStyle.value)
        }, null, 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    (props.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "label",
            ref_key: "textLabelNode",
            ref: textLabelNode
          }, _toDisplayString(__props.text), 513 /* TEXT, NEED_PATCH */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 4 /* STYLE */))
}
}

})